import * as React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path, Rect } from '../IconBase/IconBase'

const Percent = ({
  color = 'icon.primary',
  fill = 'transparent',
  stroke = 1,
  ...props
}) => (
  <IconBase viewBox='0 0 14 14' {...props}>
    <Rect
      width={12.444}
      height={12.444}
      x={0.777}
      y={0.778}
      stroke={color}
      fill={fill}
      strokeLinecap='round'
      strokeLinejoin='round'
      rx={4}
    />
    <Path
      fill={fill}
      strokeWidth={stroke}
      fillRule='evenodd'
      d='m5.156 8.85 3.692-3.692L5.156 8.85Z'
      clipRule='evenodd'
    />
    <Path
      stroke={color}
      strokeWidth={stroke}
      strokeLinecap='round'
      strokeLinejoin='round'
      d='m5.156 8.85 3.692-3.692'
    />
    <Path
      fill={fill}
      strokeWidth={stroke}
      fillRule='evenodd'
      d='M9.014 8.716a.207.207 0 1 1-.298.289.207.207 0 0 1 .298-.289Z'
      clipRule='evenodd'
    />
    <Path
      stroke={color}
      strokeWidth={stroke}
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M9.014 8.716a.207.207 0 1 1-.298.289.207.207 0 0 1 .298-.289'
    />
    <Path
      fill={fill}
      strokeWidth={stroke}
      fillRule='evenodd'
      d='M5.284 4.984a.207.207 0 1 1-.298.288.207.207 0 0 1 .298-.288Z'
      clipRule='evenodd'
    />
    <Path
      stroke={color}
      strokeWidth={stroke}
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M5.284 4.984a.207.207 0 1 1-.298.288.207.207 0 0 1 .298-.288'
    />
  </IconBase>
)

Percent.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
  stroke: PropTypes.number,
}

export default Percent
